// extracted by mini-css-extract-plugin
export var body = "_e3-0";
export var sectionHeader = "_e3-4";
export var shortcutColumns = "_e3-2";
export var shortcutList = "_e3-1";
export var shortcutSection = "_e3-3";